"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _reactSvg = require("react-svg");
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
require("./ImageThumbnails.scss");

/* copied this file from AEM repo */
var PREV = -1;
var NEXT = 1;
var WIDTH_PER_THUMBNAIL = 86;
var ImageThumbnails = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2.default)(ImageThumbnails, _React$PureComponent);
  function ImageThumbnails(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.handleSlide = function (dir) {
      var newIndex = _this.state.firstIndex + dir; // check the boundaries to prevent sliding beyond left/right boundary

      if (dir === PREV && newIndex === -1) {
        return;
      }
      if (dir === NEXT && newIndex >= _this.getLastIndex(_this.props.width, _this.props.items.length) + 1) {
        return;
      }
      if (dir === NEXT) {
        _this.handleSlideNext(_this.state.firstIndex, newIndex);
      } else {
        _this.handleSlidePrev(_this.state.firstIndex, newIndex);
      }
    };
    _this.getSlideDelay = function () {
      return _screenSizes.default.isTabletAndUnder() ? 125 : 250;
    };
    _this.handleSlideNext = function (currentIndex, newIndex) {
      // delay so the CSS transition for sliding is not prevented
      setTimeout(function () {
        return _this.refs[currentIndex].current.style.display = 'none';
      }, _this.getSlideDelay());
      _this.setState({
        firstIndex: newIndex
      });
    };
    _this.handleSlidePrev = function (currentIndex, newIndex) {
      // delay both statements to allow fast continous sliding
      // this will happend if the user continously clicks the previous button
      setTimeout(function () {
        return _this.refs[newIndex].current.style.display = '';
      }, 25);
      setTimeout(function () {
        return _this.setState({
          firstIndex: newIndex
        });
      }, 50);
    };
    _this.handleTouchStart = function (e) {
      var touch = e.touches[0];
      _this.setState({
        xStart: touch.clientX,
        yStart: touch.clientY
      });
    };
    _this.handleTouchMove = function (e) {
      var touch = e.touches[0];
      _this.setState({
        xMove: touch.clientX,
        yMove: touch.clientY
      });
    };
    _this.handleTouchEnd = function (e) {
      if (_this.state.xMove === 0) return;
      if (_this.state.xStart < _this.state.xMove) {
        _this.handleSlide(PREV);
      } else {
        _this.handleSlide(NEXT);
      }
      _this.setState({
        xStart: 0,
        yStart: 0,
        xMove: 0,
        yMove: 0
      });
    };
    _this.getItemClassName = function (index) {
      if (index < _this.state.firstIndex) {
        return "image-thumbnails-container__item--hidden " + (_this.state.selectedIndex === index ? 'image-thumbnails-container__item--selected' : '');
      }
      return "image-thumbnails-container__item--visible " + (_this.state.selectedIndex === index ? 'image-thumbnails-container__item--selected' : '');
    };
    _this.handleItemClick = function (item, index) {
      if (_this.props.onItemClick) {
        _this.props.onItemClick({
          item: item,
          index: index
        });
      }
      _this.setState({
        selectedIndex: index
      });
    };
    _this.renderItems = function () {
      // refs are used to toggle the display property for each item during sliding
      // and to highlight the selected that has been clicked
      _this.refs = [];
      (0, _lodash.forEach)(_this.props.items, function (item) {
        _this.refs.push(_react.default.createRef());
      });
      return _this.props.items.map(function (item, index) {
        var key = "image-div-" + index;
        return _react.default.createElement("div", {
          ref: _this.refs[index],
          key: key,
          className: "image-thumbnails-container__item " + _this.getItemClassName(index),
          onClick: function onClick(e) {
            return _this.handleItemClick(item, index);
          }
        }, item);
      });
    };
    _this.getPrevButtonClassName = function () {
      return _this.state.firstIndex === 0 ? 'image-thumbails-button--disabled' : '';
    };
    _this.getNextButtonClassName = function () {
      var lastIndex = _this.getLastIndex(_this.props.width, _this.props.items.length);
      if (_this.state.firstIndex === lastIndex) {
        return 'image-thumbails-button--disabled';
      }
      return '';
    };
    _this.getTotalVisibleItems = function (width, widthPerThumbnail) {
      return Math.floor((width - (_screenSizes.default.isTabletAndUnder() ? 0 : 100)) / widthPerThumbnail);
    };
    _this.getLastIndex = function (width, totalItems) {
      return totalItems - _this.getTotalVisibleItems(width, WIDTH_PER_THUMBNAIL);
    };
    _this.getImageThumbnailsWrapperStyle = function () {
      // check if scrolling thumbnails is needed
      // if scrolling is needed, set width and show the next and previous buttons
      // if scrolling is not needed, no need for width and buttons... simply center images
      var totalVisibleItems = _this.getTotalVisibleItems(_this.props.width, WIDTH_PER_THUMBNAIL);
      if (_this.props.items.length <= totalVisibleItems) {
        return {};
      }
      return {
        width: _this.props.width + "px"
      };
    };
    _this.getImageThumbnailsWrapperClassName = function () {
      // check if scrolling thumbnails is needed
      // if scrolling is needed, set width and show the next and previous buttons
      // if scrolling is not needed, no need for width and buttons... simply center images
      var totalVisibleItems = _this.getTotalVisibleItems(_this.props.width, WIDTH_PER_THUMBNAIL);
      if (_this.props.items.length <= totalVisibleItems) {
        return 'image-thumbnails-wrapper--no-x-scroll';
      }
      return '';
    };
    _this.gradientLeft = function () {
      if (_this.state.firstIndex !== 0) {
        _this.addGradientLeft();
      } else {
        _this.removeGradientLeft();
      }
    };
    _this.gradientRight = function () {
      var lastIndex = _this.getLastIndex(_this.props.width, _this.props.items.length);
      if (_this.state.firstIndex < lastIndex) {
        _this.addGradientRight();
      } else {
        _this.removeGradientRight();
      }
    };
    _this.addGradientLeft = function () {
      if (_this.gradientLeftRef.current) {
        _this.gradientLeftRef.current.style.display = 'block';
      }
    };
    _this.removeGradientLeft = function () {
      if (_this.gradientLeftRef.current) {
        _this.gradientLeftRef.current.style.display = 'none';
      }
    };
    _this.addGradientRight = function () {
      if (_this.gradientRightRef.current) {
        _this.gradientRightRef.current.style.display = 'block';
      }
    };
    _this.removeGradientRight = function () {
      if (_this.gradientRightRef.current) {
        _this.gradientRightRef.current.style.display = 'none';
      }
    };
    _this.gradientLeftRef = _react.default.createRef();
    _this.gradientRightRef = _react.default.createRef();
    _this.refs = [];
    _this.state = {
      firstIndex: 0,
      selectedIndex: 0,
      xStart: 0,
      yStart: 0,
      xMove: 0,
      yMove: 0
    };
    return _this;
  }
  var _proto = ImageThumbnails.prototype;
  _proto.render = function render() {
    var _this2 = this;
    return _react.default.createElement("div", {
      className: "image-thumbnails-wrapper " + this.getImageThumbnailsWrapperClassName(),
      style: this.getImageThumbnailsWrapperStyle(),
      "data-locator": "image-thumbnails-wrapper"
    }, _react.default.createElement("div", {
      className: "image-thumbnails-button " + this.getPrevButtonClassName(),
      "data-locator": "image-thumbnails-button",
      onClick: function onClick(e) {
        return _this2.handleSlide(PREV);
      }
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: "/content/dam/waters/en/brand-assets/icons/left.svg"
    })), _react.default.createElement("div", {
      className: "image-thumbnails-container",
      onTouchStart: this.handleTouchStart,
      onTouchMove: this.handleTouchMove,
      onTouchEnd: this.handleTouchEnd
    }, _react.default.createElement("div", {
      ref: this.gradientLeftRef,
      className: "image-thumbnails-wrapper__gradient-left",
      "data-locator": "image-thumbnails-left-button"
    }), this.renderItems(), _react.default.createElement("div", {
      ref: this.gradientRightRef,
      className: "image-thumbnails-wrapper__gradient-right",
      "data-locator": "image-thumbnails-right-button"
    })), _react.default.createElement("div", {
      className: "image-thumbnails-button " + this.getNextButtonClassName(),
      onClick: function onClick(e) {
        return _this2.handleSlide(NEXT);
      }
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: "/content/dam/waters/en/brand-assets/icons/right.svg"
    })));
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (_screenSizes.default.isTabletAndUnder()) {
      this.gradientLeft();
      this.gradientRight();
    }
  };
  return ImageThumbnails;
}(_react.default.PureComponent);
var _default = ImageThumbnails;
exports.default = _default;
module.exports = exports["default"];